import React, { useContext, useState } from "react";
import DatePicker from "react-datepicker";
import FormTriggers from "../../../layouts/FormTriggers";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import { InsuranceCompanyList } from "../../../utils/constant";
import { axios_instance } from "../../../api/axios_instance";
import FormButtons from "./FormButtons";
import { toast } from "react-toastify";
import {
  checkHoldCase,
  getCompletedStepDetails,
  holdCaseMessage,
  insuranceFormValidate,
} from "../../../utils/detail";
import { DetailFormContext } from "../../../ContextAPI/context";

const InsuranceCheck = ({
  fieldValues,
  stepSelected,
  handleNextStep,
  user,
  isVerificationRequired,
  Message,
  dtsCheckpoints,
  fetchCaseData,
  caseDetails,
}) => {
  const { panelTitle, stepTitle, setDetailFormButtonClicked } =
    useContext(DetailFormContext);
  const { stepDetails, requiredSubStepFields } = fieldValues;
  const { checklist, btnDraftType } = stepDetails;
  const {
    finance_lead_id,
    id,
    insurance_expiry_date,
    insurance_number,
    insurance_company,
    insurance_dv,
    stage,
    sub_stage,
    insurance,
    bank_id,
    is_prepayment_raised,
    step_details,
    maker_id,
  } = caseDetails;

  const initialState = {
    expiry_date:
      insurance_expiry_date && insurance_expiry_date !== "0000:00:00"
        ? new Date(insurance_expiry_date)
        : "",
    insuranceNumber: insurance_number,
    insuranceCompany: insurance_company,
    insuranceDv: insurance_dv,
    showExpiryDateError: false,
    showInsuranceNumberError: false,
    showInsuranceCompanyError: false,
    showInsuranceDvError: false,
  };

  const [state, setState] = useState(initialState);

  // Check visibility conditions for each field
  const isExpiryDateVisible =
    requiredSubStepFields?.expiry_date?.is_visible === 1;
  const isPolicyNumberVisible =
    requiredSubStepFields?.policy_number?.is_visible === 1;
  const isCompanyInsuranceVisible =
    requiredSubStepFields?.company_insurance?.is_visible === 1;
  const isIdvInsuranceVisible =
    requiredSubStepFields?.idv_insurance?.is_visible === 1;

  // Check if any field requires verification
  const calculatedIsVerificationRequired =
    isExpiryDateVisible ||
    isPolicyNumberVisible ||
    isCompanyInsuranceVisible ||
    isIdvInsuranceVisible;

  const handleDateChange = (value) => {
    setState({ ...state, expiry_date: value, showExpiryDateError: !value });
  };

  const saveDetails = async () => {
    const stepDetails = getCompletedStepDetails(
      step_details,
      sub_stage,
      stepSelected
    );
    await axios_instance({
      url: "/dts/saveInsuranceDetails",
      method: "POST",
      data: {
        finance_lead_id: +finance_lead_id,
        form: stepSelected,
        stage: +stage,
        sub_stage: +sub_stage,
        type: btnDraftType,
        step_details: stepDetails,
        insurance,
        bank_id,
        is_prepayment_raised,
        insurance_expiry_date: state.expiry_date,
        insurance_number: state.insuranceNumber,
        insurance_company: state.insuranceCompany,
        insurance_idv: state.insuranceDv,
        disbursement_id: +id,
      },
    });
    await fetchCaseData();
  };

  const handleSaveAndNext = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (!insuranceFormValidate(state, setState, requiredSubStepFields)) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
      handleNextStep();
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleSaveAsDraft = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (!insuranceFormValidate(state, setState, requiredSubStepFields)) {
        toast.dismiss();
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleInputChange = (inputName, value, errorId) => {
    setState({ ...state, [inputName]: value, [errorId]: false });
  };
  return (
    <>
      <div
        className="table-responsive chklist-box-scroll mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        data-mcs-theme="minimal-dark"
      >
        {isVerificationRequired && calculatedIsVerificationRequired ? (
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            >
              <form id="insurance_check">
                <table className="table table-bordered disburse-table">
                  <thead>
                    <tr>
                      <th width="76%" colSpan="2">
                        {panelTitle} - {stepTitle}
                      </th>
                      {checklist && <th width="24%">L1</th>}
                    </tr>
                  </thead>
                  <tbody className="form-table">
                    {isExpiryDateVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.expiry_date?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div
                            className="input-append date "
                            id="insurance_expiry_date_ed"
                          >
                            <DatePicker
                              selected={state.expiry_date}
                              onChange={(date) => handleDateChange(date)}
                              placeholderText="Enter Expiry Date"
                              className={`span2 form-control add-on calender filter-tb date-bg_input ${
                                state.showExpiryDateError ? "errorInput" : ""
                              }`}
                              dateFormat="dd-MM-yyyy"
                              required
                              disabled={
                                requiredSubStepFields?.expiry_date
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_insurance_expiry_date"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="insurance_expiry_date"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isPolicyNumberVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.policy_number?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="insurance_number"
                              className={`form-control insurance-form-input ${
                                state.showInsuranceNumberError
                                  ? "errorInput"
                                  : ""
                              }`}
                              placeholder="Insurance Policy Number"
                              required
                              disabled={
                                requiredSubStepFields?.policy_number
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.insuranceNumber}
                              onChange={(e) =>
                                handleInputChange(
                                  "insuranceNumber",
                                  e.target.value,
                                  "showInsuranceNumberError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_insurance_number"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="insurance_number"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isCompanyInsuranceVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.company_insurance?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <span>
                            <SingleSelectDropDown
                              dataArr={InsuranceCompanyList}
                              handleChange={(e) =>
                                handleInputChange(
                                  "insuranceCompany",
                                  e.target.value,
                                  "showInsuranceCompanyError"
                                )
                              }
                              name="insurance_company"
                              required={true}
                              disabled={
                                requiredSubStepFields?.company_insurance
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.insuranceCompany}
                              className={
                                state.showInsuranceCompanyError
                                  ? "errorInput"
                                  : ""
                              }
                              divClassName="form-group payment-dropdown-tranche-form"
                            />
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="insurance_company"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isIdvInsuranceVisible && (
                      <tr>
                        <td>
                          {requiredSubStepFields?.idv_insurance?.name}
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          <div className="input-append date input-group input-sm">
                            <input
                              type="text"
                              name="insurance_idv"
                              className={`form-control insurance-form-input ${
                                state.showInsuranceDvError ? "errorInput" : ""
                              }`}
                              placeholder="Insurance IDV"
                              required
                              disabled={
                                requiredSubStepFields?.idv_insurance
                                  ?.is_editable === 1
                                  ? stepDetails.disableMaker
                                  : "disabled"
                              }
                              value={state.insuranceDv}
                              onChange={(e) =>
                                handleInputChange(
                                  "insuranceDv",
                                  e.target.value,
                                  "showInsuranceDvError"
                                )
                              }
                            />
                          </div>
                          <div
                            className="errorTxt"
                            id="error_insurance_idv"
                          ></div>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="insurance_idv"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        ) : (
          <div className="disburse-table no-form">
            There are no verification required in this section. Please click
            Next/Skip to proceed
          </div>
        )}
      </div>
      <FormButtons
        caseDetails={caseDetails}
        user={user}
        stepDetails={stepDetails}
        handleNextButtonClick={handleNextStep}
        handleSaveAndNext={handleSaveAndNext}
        handleSaveAsDraft={handleSaveAsDraft}
        isVerificationRequired={calculatedIsVerificationRequired}
        isReadOnlyUser={fieldValues.isReadOnlyUser}
      />
    </>
  );
};

export default InsuranceCheck;
